import axiosInstance from "../api/axios";

/* BuildVizer-internal (developer-less) project owners. ZUMALE-admin only. */

export const listInternalOwners = (params) => axiosInstance.get(`/admin/owners`, { params });

// body: RequestCustomerAccountData (customerType + isBvManaged are forced server-side)
export const createInternalOwner = (body) => axiosInstance.post(`/admin/owners`, body);

// Attach/create a channel partner on the owner's projects.
// body: { agentData: RequestCustomerAccountData, propertyConfigIds: [], projectIds: [] }
export const attachChannelPartner = (ownerId, body) =>
  axiosInstance.post(`/admin/owners/${ownerId}/channel-partners`, body);
